import { render } from "./releasePublic.vue?vue&type=template&id=2c2a5fda&scoped=true"
import script from "./releasePublic.vue?vue&type=script&lang=js"
export * from "./releasePublic.vue?vue&type=script&lang=js"

import "./releasePublic.vue?vue&type=style&index=0&id=2c2a5fda&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2a5fda"]])

export default __exports__